import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import AppContext from '../../config/AppContext';
import FeaturesList from './FeaturesList';
import { ReactComponent as Active } from '../../assets/subscription/Active.svg';
import { ReactComponent as Cancelled } from '../../assets/subscription/Cancelled.svg';
import './style/PlansFeatures.scss';
import { Box } from '@mui/material';

const PlansFeatures = ({ planFeature, isActivePlan, index }) => {
  const { t } = useTranslation();
  const { mode } = useContext(AppContext);
  let { features } = FeaturesList();

  // For Integer value featureCode
  const valFtsCode = ["MEMBER_COUNT", "PROJECT_COUNT", "TAG_COUNT", "DAILY_AI_SUMMARIZATION_LIMITS"];

  if (planFeature && planFeature.length > 0) {
    const updatedFt = features.map((ft) => {
      const pf = planFeature.find(pf => pf.feature_code === ft.feature_code);
      if (!pf) return ft;

      if (valFtsCode.includes(pf.feature_code) && pf.feature_code === ft.feature_code) {
        return {
          ...ft,
          currentValue: pf.value,
        };
      }
      if (pf.value === "All") {
        return {
          ...ft,
          currentValue: true,
        };
      }
      if (pf.value?.includes(ft.defaultValue)) {
        return {
          ...ft,
          currentValue: true,
        };
      }
      return ft; // Return the original feature if no conditions are met
    });
    features = updatedFt;
  }

  return (
    <div
      className="plan-feature-main"
      style={{
        background:
          mode === "dark"
            ? isActivePlan
              ? "#A49DC8"
              : "#333333"
            : isActivePlan
              ? "rgba(164, 157, 200, 0.15)"
              : "#FFFFFF",
      }}
    >
      <div>
        {features.map((ft, index) => (
          <Box key={index} className="plan-feature-box"
            sx={{
              margin: index === 0 ? 0 : "20px 0 0 0 !important",
              '@media (max-width: 1600px)': {
                margin: index === 0 ? 0 : "15px 0 0 0 !important"
              },
            }}
          >
            {valFtsCode.includes(ft.feature_code) ? (
              <span
                style={{
                  color: mode === "dark"
                    ? isActivePlan
                      ? "#242424"
                      : "#f8f8f8cc"
                    : "#242424",
                }}
              >{ft.currentValue}</span>
            ) : ft.currentValue === true ? (
              <Active className="plan-feature-icon" />
            ) : (
              <Cancelled className="plan-feature-icon" />
            )}
          </Box>
        ))}
      </div>
    </div>
  );
};

export default PlansFeatures;
